module.exports = __webpack_public_path__ + "images/FUSA_icons/081-box.d36307db7aeb6ba5b710bbfeaddb8555.svg";